export default __webpack_public_path__ + "static/media/tick2.173b7e14.svg";